module.exports = __webpack_public_path__ + "static/img/rnd2.ea1cc70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/rnd2.png
// module id = 1261
// module chunks = 0